module.exports = __webpack_public_path__ + "img/Home.41d2bf07.svg";